import type { FC, ReactNode } from 'react';
import './index.less';

export const FloatMenu: FC<{
  top: number;
  left: number;
  menus: Array<{
    label: ReactNode;
    onClick: () => void;
  }>;
}> = (props) => {
  // props
  const { top, left, menus } = props;

  return (
    <section
      className="fm-wrapper absolute top-0 left-0 flex"
      style={{ top, left }}
    >
      {menus.map((menu, idx) => {
        const { label, onClick } = menu;

        return (
          <button
            key={idx}
            type="button"
            className="flex justify-center items-center w-10 text-sm text-secondary-1 hover:text-primary hover:bg-[#EFF1F6]"
            onClick={onClick}
          >
            {label}
          </button>
        );
      })}
    </section>
  );
};
